import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyCkFL8G3kgAMRj5hfBooeveDZ-I0ubdH_w",
  authDomain: "lateral-now-287314.firebaseapp.com",
  projectId: "lateral-now-287314",
  storageBucket: "lateral-now-287314.appspot.com",
  messagingSenderId: "599257757316",
  appId: "1:599257757316:web:2d82f87478e75abc5fb4d1"
};

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)